import { CheckCircle, InfoOutlined } from "@mui/icons-material";
import { Box, Popover, IconButton } from "@mui/material";
import { green } from "@mui/material/colors";
import React, { useState } from "react";
import passwordRequirements from "../../../config/passwordRequirements.json";

const PasswordRequirement: React.FunctionComponent<any> = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <>
      <Box className="infoRowInput">
        <Popover
          id="mouse-over-popover"
          sx={{
            pointerEvents: "none",
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <ul className="listwithIcon">
            {passwordRequirements.passwordRequirements?.map(
              (text: any, key: any) => (
                <li key={key}>
                  <CheckCircle sx={{ color: green[500] }} fontSize="small" />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: text,
                    }}
                  />
                </li>
              )
            )}
          </ul>
        </Popover>
        <IconButton
          aria-label="Password Requirments"
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
          sx={{ ml: -1 }}
        >
          <InfoOutlined color="primary" />
        </IconButton>{" "}
        Password Requirements
      </Box>
    </>
  );
};

export default PasswordRequirement;
